<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" style="padding: 1em;">
      <div class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription">
        <header class="modal-header" id="modalTitle">
            {{mode==1?'新增':'修改'}}推薦人資料
        </header>
        <section class="modal-body" id="modalDescription">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">{{$t('message.Save_cmd')}}</el-button>
                    <el-button type="info" @click="$emit('close')" round>{{$t('message.Close_cmd')}}</el-button>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item> 
                <el-form-item label="任職單位" prop="unit">
                    <el-input v-model="form.unit"></el-input>
                </el-form-item> 
                <el-form-item label="職稱" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item> 
                <el-form-item label="與申請人關係" prop="relation">
                    <el-input v-model="form.relation"></el-input>
                </el-form-item> 
                <el-form-item label="Email" prop="eMail">
                    <el-input v-model="form.eMail"></el-input>
                </el-form-item> 
                <el-form-item label="連絡電話" prop="phoneNo">
                    <el-input v-model="form.phoneNo"></el-input>
                </el-form-item> 
            </el-form>
 <!--            <el-row>
                <el-button type="success" @click="save()" round>{{$t('message.Save_cmd')}}</el-button>
                <el-button type="info" @click="$emit('close')" round>{{$t('message.Close_cmd')}}</el-button>
            </el-row>
            <div class='well'
                style="display:inline-table; padding: 0.1875em; width: 100%;"> 
                <table style="border:2.5px solid;padding:5px;width:98%;" rules="all" cellpadding='5' >
                    <tbody style="line-height:2em;">
                        <tr style="height:3.5em;">
                            <td class="ncut-edit-form-text" style="width:6.25em; padding: 0.3em;">姓名</td>
                            <td class="ncut-base-form-ipt"  style="padding: 0.3em;">
                                {{inputData.name}}
                            </td>
                            <td class="ncut-edit-form-text" style="width:6.25em; padding: 0.3em;">任職單位</td>
                            <td class="ncut-base-form-ipt"  style="padding: 0.3em; width:12em;">
                                {{inputData.unit}}
                            </td>
                        </tr>
                        <tr style="height:3.5em;">
                            <td class="ncut-edit-form-text" style="width:6.25em; padding: 0.3em;">職稱</td>
                            <td class="ncut-base-form-ipt" colspan="3" style="padding: 0.3em;">
                                <el-input v-model="inputData.title" tabindex="1"></el-input>
                            </td>
                        </tr>
                        <tr style="height:3.5em;">
                            <td class="ncut-edit-form-text" style="padding: 0.3em;">與申請人關係</td>
                            <td class="ncut-base-form-ipt" style="padding: 0.3em;">
                                <el-input v-model="inputData.relation" tabindex="2" style="width:12em;"></el-input>
                            </td>
                            <td class="ncut-edit-form-text" style="padding: 0.3em;">Email</td>
                            <td class="ncut-base-form-ipt" style="padding: 0.3em;">
                                <el-input v-model="inputData.eMail" tabindex="5"></el-input>
                            </td>
                        </tr>
                        <tr style="height:3.5em;">
                            <td class="ncut-edit-form-text" style="padding: 0.3em;">連絡電話</td>
                            <td class="ncut-base-form-ipt" style="padding: 0.3em;">
                                <el-input v-model="inputData.phoneNo" tabindex="2" style="width:12em;"></el-input>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'editData',
  props: [
    'recId', 'mode'
  ],
  data () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能空白'));
      } else {
        callback();
      }
    };
    var checkUnit = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('任職單位不能空白'));
      } else {
        callback();
      }
    };
    var checkTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('職稱不能空白'));
      } else {
        callback();
      }
    };
    var checkRelation = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('與申請人關係不能空白'));
      } else {
        callback();
      }
    };
    var checkEMail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Email不能空白'));
      } else {
        callback();
      }
    };
    return {
      form: {
        name: '',
        unit: '',
        title: '',
        relation: '',
        eMail: '',
        phoneNo: ''
      },
      rules:{
       name:[{validator: checkName,trigger:"blur"}],
       unit:[{validator: checkUnit,trigger:"blur"}],
       title:[{validator: checkTitle,trigger:"blur"}],
       relation:[{validator: checkRelation,trigger:"blur"}],
       eMail:[{validator: checkEMail,trigger:"blur"}],
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    checkSaveData () {
      let msg = '' 
      
      if ((null == this.inputData.name) || (this.inputData.name.length == 0)) {
        msg = '姓名';
      } else if ((null == this.inputData.phoneNo1) || (this.inputData.phoneNo1.length < 10)) {
        msg = '行動電話';
      }

      return msg
    },
    submitForm(form) {
      this.$refs.form.validate((valid) => {        
        console.log('======submitForm ===== valid:'+valid)
        if (valid) {
          var vm = this
          this.$http.put('./WebApi/Apply/SetRecommendInfo',this.form)
                    .then((response) =>{ 
                        const h = vm.$createElement;       
                        if (true == response.data) {
                            vm.$notify({
                                      title: vm.$t('message.Success_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>恭喜您,存檔成功</strong>',
                                      type: 'success',
                                      offset: 150
                                    });
                            vm.$emit('close')
                        } else {
                            vm.$notify.error({
                                            title: vm.$t('message.Error_txt'),
                                            dangerouslyUseHTMLString: true,
                                            message: '<strong>對不起,寄件失敗</strong>',
                                            offset: 150
                                          });
                        }
                    })
                    .catch(function (error) {
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                        offset: 150
                                      });
                    })
        } else {
          this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,驗證失敗</strong>',
                              offset: 150
                            });
          return false;
        }
      });
    },
    save () {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this
        this.inputData.eId = this.setting.enrollID[0].codeName;
        this.inputData.updateUser = this.user.id;

        this.$http.put('./WebApi/Apply/SetRecommendInfo', this.inputData)
          .then((response) => {
            if (response.data === true) {
              vm.$message({
                message: '恭喜您,存檔成功',
                type: 'success'
              })
              vm.$emit('close')
            }
            else {
              vm.$message.error('對不起,存檔失敗')
            }
          })
          .catch(function (error) {
            vm.$message.error('對不起,網路連線失敗' + error)
          })
      } else {
        var msgStr = enrollTools.stringFormat("對不起,請輸入{0}!", msg);
        enrollTools.showErrorMessage(msgStr);
      }
    },
    getRecommendData: function () {
      return this.$http
        .get('./WebApi/Apply/GetRecommendInfo/'.concat(this.recId));
    },
  },
  created () {
    console.log('======created EditData =====')
    let vm = this
    this.$http.all([this.getRecommendData()])
        .then(vm.$http.spread(function (data1) {
            if (data1.data != null) {
                vm.form.name = data1.data.name;
                vm.form.title = data1.data.title;
                vm.form.unit = data1.data.unit;
                vm.form.relation = data1.data.relation;
                vm.form.eMail = data1.data.eMail;
                vm.form.phoneNo = data1.data.phoneNo;
            }
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pull-right {
  float: right;
}
.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
  box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
</style>


// WEBPACK FOOTER //
// src/components/EditData copy.vue